module.exports = __webpack_public_path__ + "static/media/pta-logo2.9fa09958.png";